/** For `unit.dateRange('updatedAt', { ...UPDATED_AT_FILTER_TEXT })`. */
export const UPDATED_AT_FILTER_TEXT = { title: 'Updated at', description: 'Filter by last updated date range' };
